module.exports = __webpack_public_path__ + "img/group-outlet_cykel.9cff5b32.png";